import { UnitsPerPieceType } from '@prisma/client';
import { stringToEnum } from '@snap-types/models/common';

export const unitsPerPieceTypeSchema = stringToEnum(UnitsPerPieceType);
